import React from 'react'
import { useSelector } from 'react-redux'
import { CREDIT_CARD_MODAL_STAGE } from 'app-constants'
import { GoToPaymentLink, CreditCardError } from './components'

function stages({ ...props }) {
  return {
    [CREDIT_CARD_MODAL_STAGE.INITIAL]: <GoToPaymentLink {...props} />,
    [CREDIT_CARD_MODAL_STAGE.ERROR]: <CreditCardError {...props} />,
  }
}

export function CreditCardModal() {
  const { stage, data } = useSelector(({ modal }) => modal)

  return stages({ paymentLink: data?.paymentLink })[stage]
}
